import { Link as MuiLink } from "@mui/material";
import { PropsWithChildren, ComponentProps } from "react";
import { HistoryState, Link } from "@tanstack/react-router";
import RouterLinkButton from "./components";

type Props = PropsWithChildren<{ to: string; color?: string; "data-testid"?: string }>;

const RouterLink = ({ children, to, color, "data-testid": dataTestId }: Props) => {
  return (
    <MuiLink component={Link} to={to} underline="hover" color={color} data-testid={dataTestId}>
      {children}
    </MuiLink>
  );
};

type ButtonProps = PropsWithChildren<{ to: string; state?: Partial<HistoryState> }> &
  Pick<
    ComponentProps<typeof RouterLinkButton>,
    "variant" | "color" | "size" | "disabled" | "sx" | "onClick" | "target"
  >;

RouterLink.Button = function Button(props: ButtonProps) {
  return <RouterLinkButton {...props} />;
};

export default RouterLink;
